type BrandAssetProps = {
  className?: string;
};

export type PatchPose = "point" | "welcome" | "map" | "lookout" | "help";

export function AutterWordmark({ className = "" }: BrandAssetProps) {
  return <img src="/autter-assets/autter-wordmark-light.png" alt="Autter" className={className} />;
}

export function AutterWordmarkOnDark({ className = "" }: BrandAssetProps) {
  return <img src="/autter-assets/wordmark-dark.png" alt="Autter" className={className} />;
}

const patchPoseLabels: Record<PatchPose, string> = {
  point: "Captain Patch pointing the way",
  welcome: "Captain Patch welcoming the crew",
  map: "Captain Patch reading a nautical map",
  lookout: "Captain Patch looking through a spyglass",
  help: "Captain Patch offering a helping paw",
};

export function CaptainPatchImage({
  pose = "point",
  className = "",
  decorative = false,
}: BrandAssetProps & { pose?: PatchPose; decorative?: boolean }) {
  return (
    <img
      src={`/patch-poses/patch-${pose}.png`}
      alt={decorative ? "" : patchPoseLabels[pose]}
      aria-hidden={decorative || undefined}
      className={`object-contain ${className}`}
    />
  );
}

/** Legacy alias retained for callers outside the reader page. */
export function OfficialPatch({ className = "" }: BrandAssetProps) {
  return (
    <CaptainPatchImage pose="point" className={className} />
  );
}

export function AutterAnchor({ className = "" }: BrandAssetProps) {
  return <img src="/autter-assets/autter-mascot.svg" alt="" aria-hidden className={className} />;
}
